import { render, staticRenderFns } from "./MessageModal.vue?vue&type=template&id=072df542&scoped=true"
import script from "./MessageModal.vue?vue&type=script&lang=ts"
export * from "./MessageModal.vue?vue&type=script&lang=ts"
import style0 from "./MessageModal.vue?vue&type=style&index=0&id=072df542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072df542",
  null
  
)

export default component.exports